.button {
    display: inline;

    border: none;
    border-radius: calc(infinity * 1px);

    padding: 0;

    text-align: start;
    color: var(--colorTextSecondary);
    font-family: var(--fontFamilySansRegular), sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
    text-decoration: underline;

    background-color: transparent;

    cursor: pointer;
    outline: none;
}

.button[data-hovered],
.button[data-pressed] {
    text-decoration: none;
}

.button[data-focus-visible] {
    outline-style: solid;
    outline-width: 1px;
    outline-color: var(--colorBorderAccent);
    outline-offset: var(--spacing-xxs);
}

.button[data-disabled] {
    color: var(--colorTextDisabled);
    cursor: default;
}

.primary {
    color: var(--colorTextPrimary);
}
